<app-dialog-content-layout
  headerTitle="keyboardShortcuts"
  [showFooter]="false"
  (cancel)="close()"
  [showBgImage]="false"
>
  <div class="flex flex-col gap-sm">
    @for (item of shortcuts; track item.labelKey) {
    <div class="flex flex-col gap-xs p-sm rounded-lg bg-white shadow-card">
      <div class="flex justify-between items-center text-sm font-semibold">
        <span class="text-dark-text font-bold">{{ item.labelKey | translate }}</span>
        <kbd class="px-2 py-1 rounded bg-white text-[11px] font-bold text-primary shadow-sm border border-line font-mono select-none">
          {{ item.keys }}
        </kbd>
      </div>
      <span class="text-xs text-gray-text leading-snug">
        {{ item.descKey | translate }}
      </span>
    </div>
    }
  </div>
</app-dialog-content-layout>
